function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23418"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17772",
    d: "M6.111 5.489V3m4.978 2.489V3m-5.6 4.978h6.222M4.244 14.2h8.711a1.244 1.244 0 0 0 1.245-1.244V5.489a1.244 1.244 0 0 0-1.244-1.244H4.244A1.244 1.244 0 0 0 3 5.489v7.467A1.244 1.244 0 0 0 4.244 14.2z",
    transform: "translate(-.5 -.5)",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1919",
    d: "M16 16H0V0h16z",
    transform: "rotate(-90 8 8)",
    style: {
      opacity: 0.87,
      fill: "none"
    }
  })));
};

export default SvgCalendar;